var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCallList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#818181;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    className: "cls-1",
    cx: 13,
    cy: 13,
    r: 13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_003---Call",
    "data-name": " 003---Call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M11.77,15.23A5.81,5.81,0,0,1,10,12a.5.5,0,0,1,.14-.42l1.11-1.1a.5.5,0,0,0,.07-.61L9.58,7.08a.5.5,0,0,0-.65-.18L6.11,8.23a.49.49,0,0,0-.28.49A13.72,13.72,0,0,0,10,17a13.72,13.72,0,0,0,8.28,4.17.49.49,0,0,0,.49-.28l1.33-2.83a.49.49,0,0,0-.18-.64l-2.74-1.76a.5.5,0,0,0-.61.07l-1.1,1.11a.5.5,0,0,1-.42.14A5.81,5.81,0,0,1,11.77,15.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-2",
    d: "M17.21,14.49a.48.48,0,0,1-.5-.48h0A3.73,3.73,0,0,0,13,10.29a.49.49,0,1,1,0-1A4.7,4.7,0,0,1,17.7,14h0A.49.49,0,0,1,17.21,14.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    className: "cls-2",
    d: "M19.67,14.49a.49.49,0,0,1-.49-.49A6.18,6.18,0,0,0,13,7.82a.5.5,0,0,1,0-1A7.18,7.18,0,0,1,20.17,14a.49.49,0,0,1-.49.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallList);
export default __webpack_public_path__ + "static/media/IconCallList.658de38ea16ffd8824097f28d69cc45f.svg";
export { ForwardRef as ReactComponent };